import React, { useEffect, useState } from 'react';
import { IonContent, IonPage } from '@ionic/react';
import { useHistory, useLocation } from "react-router-dom";
import './Splash.scss';
import { baseUrl } from '../helpers/configHelper';
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from 'react-redux';
import * as headerFooterStore from '../store/HeaderFooterStore';
import { continueFromInitialPage } from '../helpers/configHelper';
import * as ColleaguesStore from '../store/ColleagueStore';
import { Base64 } from 'js-base64';
import Button from '../components/Button';
import { ApplicationState } from '../store';

const grantCookiePermissions = () => {
    (window as any).gtag('consent', 'update', {
        'ad_storage': 'granted',
        'analytics_storage': 'granted'
    });
}

interface ICookieConsentProps {
    onExit: () => void;
}

const CookieConsent = (props: ICookieConsentProps) => {
    const boundSetShowModal = bindActionCreators(headerFooterStore.actionCreators.setShowModal, useDispatch());

    const showTermsAndConditions = () => {
        boundSetShowModal("TC", true, true);
    }

    const handleDecline = () => {
        localStorage.setItem('cookieConsent', 'denied');
        props.onExit();
    }

    const handleAccept = () => {
        localStorage.setItem('cookieConsent', 'granted');
        grantCookiePermissions();
        props.onExit();
    }

    return (
        <div className="consent-chaffinch">
            <div className="content-wrapper">
                <div className="content">
                    <div className="title">Giving you the best ordering experience</div>
                    <div className="information">We’d like your consent to let us use cookies to gather and analyse information about how you use this app to help us improve our service. These cookies won’t identify or track you outside of this app.</div>
                    <div className="terms-and-conditions">By continuing, you agree to our <span className="link" onClick={showTermsAndConditions}>Terms &amp; Conditions</span> Policy</div>
                    <div className="decline">
                        <span className="link" onClick={handleDecline}>
                            Decline cookies
                        </span>
                    </div>
                    <div className="accept">
                        <Button onClick={handleAccept} color="primary">
                            Accept all cookies
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

const SplashPage: React.FC = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const location = useLocation();

    const requiresLogin = true;
    const isLoggedIn = useSelector((state: ApplicationState) => state.colleague?.isLoggedIn);
    const boundSetShowModal = bindActionCreators(headerFooterStore.actionCreators.setShowModal, useDispatch());

    const [showCookieConsent, setShowCookieConsent] = useState(false);

    const boundSetHasStartedApp = bindActionCreators(
        headerFooterStore.actionCreators.setHasStartedApp, dispatch);

    useEffect(() => {
        const cookieConsent = localStorage.getItem('cookieConsent');
        const searchParams = new URLSearchParams(location.search);

        if (cookieConsent == null) {
            setShowCookieConsent(true);
        }

        const pd = searchParams.get('pd');
        if (pd) {
            const decodeEmailAndMoreCard = Base64.decode(JSON.stringify(pd));
            const splitDecodeByComma = decodeEmailAndMoreCard.split(',');

            localStorage.setItem('email', splitDecodeByComma[0]);
            localStorage.setItem('staffCardNumber', splitDecodeByComma[1]);
        }

        const isNewOrder = searchParams.get('newOrder');
        const isLoggedIn = localStorage.getItem('isLoggedIn');
        if (isNewOrder && isLoggedIn) {
            localStorage.removeItem('isLoggedIn')
            localStorage.removeItem("pfidentifier");

            dispatch(ColleaguesStore.loggedIn(false))
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const startOrder = () => {
        if(requiresLogin && !isLoggedIn){
            boundSetShowModal("LOGIN", true);
        } else {
            continueFromInitialPage(history, boundSetHasStartedApp, "/storesearch")
            //continueFromInitialPage(history, boundSetHasStartedApp, "/orderconfirmation")
            //continueFromInitialPage(history, boundSetHasStartedApp, "/payment")
        }        
    }

    return (
        <IonPage>
            <IonContent fullscreen>
                <div
                    className="splash flex flex-col items-center"
                    style={{
                        "background": `no-repeat url(${baseUrl()}/images/assets/order_type_bg_END.png) top/cover`,
                    }}
                >
                    <div className="">
                        <img alt="Morrisions Cafe logo" className="morrisons-logo" src={`${baseUrl()}/images/assets/Logo_MC.png`}></img>
                    </div>

                    {
                        requiresLogin
                        ? 
                            <div className="flex flex-col colleague-notice">
                                <h2 style={{marginBottom: "1rem"}}>COLLEAGUE<br/>ORDERING</h2>
                                <h3>ONLINE ORDERING FOR CUSTOMERS IS CURRENTLY UNAVAILABLE</h3>
                            </div>
                        :
                            <div className="flex flex-col">
                                <h2>ORDER ONLINE</h2>
                                <h3>TO EAT IN OR TAKEAWAY</h3>
                            </div>
                    }

                    <div className="row-end">
                        <Button
                            onClick={startOrder}
                            disabled={showCookieConsent}
                            expand="block"
                            color="light"
                            rounded uppercase
                        >
                            {requiresLogin ? "Colleague Log In" : " Start Your Order" }
                        </Button>

                        <div className="splash-version">b8058</div>
                    </div>

                    {showCookieConsent &&
                        <CookieConsent onExit={() => setShowCookieConsent(false)} />
                    }
                </div>
            </IonContent>
        </IonPage>
    );
};

export default SplashPage;
